/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconEditFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconEditFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconEditFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconEditFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z65fFa': alignSelf,'--mt-2-Z65fFa': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z65fFa': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z65fFa': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z65fFa': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z65fFa': opacity,'--w-10-Z65fFa': typeof width === 'number' ? `${width}px` : width,'--h-11-Z65fFa': typeof height === 'number' ? `${height}px` : height,'--a-7-Z65fFa': isAnimated ? animation : "none",'--sd-8-Z65fFa': isAnimated ? strokeDashoffset : 0,'--sd-9-Z65fFa': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconEditFilled.SvgPath"
  data-view-path={viewPath}
 d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
 style={{'--f-12-Z65fFa': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}